import PlaceholderComponentsStore from './schema/PlaceholderComponentsStore';
import { createStore } from 'satcheljs';
/**
 * Store for fallback components
 */

/**
 * initial store state, used to reset to the default values
 */
export const initialStoreStates = {
    ReadingPaneHeader: {
        lazyLoadingFailed: false,
    },
};

const placeholderComponentsStoreData: PlaceholderComponentsStore = {
    ...initialStoreStates,
};

export const getStore = createStore<PlaceholderComponentsStore>(
    'fallbackComponentsStore',
    placeholderComponentsStoreData
);

const store = getStore();

export default store;
